(function () {

  const allowedUrl = '/pages/testosterone-quiz';

  if (
    window.location.pathname.replace(/\/$/, '') !==
    allowedUrl
  ) {
    return;
  }

  console.log('Quiz tracking loaded');

  if (typeof window.fbq !== 'function') {
    console.error('fbq is not available');
    return;
  }


  // QUESTION 1
  window.fbq(
    'trackCustom',
    '1stQuestion'
  );

  console.log('1stQuestion SENT');


  // QUESTION 2
  document.addEventListener('click', function (event) {

    if (
      event.target.closest('.vitality-option')
    ) {

      window.fbq(
        'trackCustom',
        '2ndQuestion'
      );

      console.log('2ndQuestion SENT');

    }

  });


  // QUESTION 3
  document.addEventListener('click', function (event) {

    if (
      event.target.closest('.vitality-option')
    ) {

      window.fbq(
        'trackCustom',
        '3rdQuestion'
      );

      console.log('3rdQuestion SENT');

    }

  });

})();